import { connect } from 'react-redux';
import { withState } from 'recompose';
import compose from 'recompose/compose';
import { getGiftCards, getIsLoading } from '../selectors';
import { fetchGiftCards } from '../actions';
import GiftCardList from '../components/GiftCardList';
import { getShop } from '../../../auth/selectors';
import lifecycle from 'recompose/lifecycle';

const GiftCardListContainer = compose(
  connect(state => ({
    giftCards: getGiftCards(state),
    isLoading: getIsLoading(state),
    shopId: getShop(state),
  }), { fetchGiftCards }),
  withState('value', 'setValue', ''),
  lifecycle({
    componentDidMount() {
      this.props.fetchGiftCards(this.props.shopId);
    },
  }),
)(GiftCardList);

export default GiftCardListContainer;
